import React from "react";
import "../../../css/designSystem/Cards.css";

const Cards = ({ title, description, image, icon }) => {
  return (
    <div className="card">
      <div className="card-icon">{icon}</div>
      <div className="column gap-l bg-gray-3 p-xl all-radius-l">
        <h3 className="text-primary-1">{title}</h3>
        <p className="content text-primary-1">{description}</p>
      </div>
    </div>
  );
};

export default Cards;
